import { memo } from 'react';
import type { FC } from 'react';
import { GENERIC_ERROR_HEADER, GENERIC_ERROR_MESSAGE } from '../constants';

interface ErrorPageProps {
  error: { message: string };
  onRetry: () => void;
}

const ErrorPage: FC<ErrorPageProps> = memo(() => {
  return (
    <div
      role="alert"
      aria-live="assertive"
      className="error-container flex flex-col items-center text-center w-full min-h-screen pb-10"
    >
      <h1 className="text-primary text-2xl font-semibold">{GENERIC_ERROR_HEADER}</h1>
      <p className="text-black text-lg mt-4">{GENERIC_ERROR_MESSAGE}</p>
    </div>
  );
});

export default ErrorPage;